// import { useState } from "react";
// import {
//   CheckCircle,
//   Minus,
//   Plus,
//   ShoppingCart,
//   MessageCircle,
// } from "lucide-react";
// import { useCart } from "../../context/CartContext";

// const ProductInfo = ({ product }) => {
//   const [quantity, setQuantity] = useState(1);

//   const { addToCart } = useCart();

//   const increase = () => {
//     setQuantity((prev) => prev + 1);
//   };

//   const decrease = () => {
//     if (quantity > 1) {
//       setQuantity((prev) => prev - 1);
//     }
//   };

//   const formatPrice = (price) => {
//   return `TZS ${Number(price).toLocaleString()}`;
// };

//   return (
//     <div>
//       {/* Category */}
//       <span
//         className="
//           inline-block
//           px-3
//           py-1
//           rounded-full
//           bg-green-100
//           text-green-700
//           text-sm
//           font-medium
//         "
//       >
//         {product.category?.title}
//       </span>

//       {/* Product Name */}
//       <h1
//         className="
//           mt-4
//           text-3xl
//           lg:text-4xl
//           font-bold
//           text-gray-900
//         "
//       >
//         {product.name}
//       </h1>

//       {/* Price */}
//       <p
//         className="
//           mt-4
//           text-3xl
//           font-bold
//           text-green-600
//         "
//       >
//         {formatPrice(product.price)}
//       </p>

//       {/* Description */}
//       <p
//         className="
//           mt-5
//           text-gray-600
//           leading-relaxed
//         "
//       >
//         {product.shortDescription}
//       </p>

//       {/* Highlights */}
//       <div className="mt-8 space-y-3">
//         <div className="flex items-center gap-3">
//           <CheckCircle size={20} className="text-green-600" />
//           <span>{product.stock}</span>
//         </div>

//         <div className="flex items-center gap-3">
//           <CheckCircle size={20} className="text-green-600" />
//           <span>Quality Assured</span>
//         </div>

//         <div className="flex items-center gap-3">
//           <CheckCircle size={20} className="text-green-600" />
//           <span>Delivery Available</span>
//         </div>
//       </div>

//       {/* Quantity */}
//       <div className="mt-8">
//         <p className="font-semibold text-gray-900 mb-3">Quantity</p>

//         <div
//           className="
//             inline-flex
//             items-center
//             border
//             border-gray-300
//             rounded-xl
//             overflow-hidden
//           "
//         >
//           <button
//             onClick={decrease}
//             className="
//               p-3
//               hover:bg-gray-100
//             "
//           >
//             <Minus size={18} />
//           </button>

//           <span className="px-6 font-semibold">{quantity}</span>

//           <button
//             onClick={increase}
//             className="
//               p-3
//               hover:bg-gray-100
//             "
//           >
//             <Plus size={18} />
//           </button>
//         </div>
//       </div>


//       {/* Buttons */}
//       <div className="mt-10 space-y-4 flex flex-col md:flex-row md:items-center md:gap-4">
//         <button
// onClick={() =>
//   addToCart(product, quantity)
// }
// className="
// w-full
// flex
// items-center
// justify-center
// gap-2
// bg-green-600
// text-white
// py-4
// rounded-xl
// font-semibold
// hover:bg-green-700
// transition
// "
// >
// <ShoppingCart size={20}/>
// Add to Cart
// </button>

//         <button
//           className="
//             w-full
//             flex
//             items-center
//             justify-center
//             gap-2
//             border
//             border-green-600
//             text-green-600
//             py-4
//             rounded-xl
//             font-semibold
//             hover:bg-green-50
//             transition
//           "
//         >
//           <MessageCircle size={20} />
//           Contact via WhatsApp
//         </button>
//       </div>
//     </div>
//   );
// };

// export default ProductInfo;




import { useState } from "react";
import {
  CheckCircle,
  Minus,
  Plus,
  ShoppingCart,
  MessageCircle,
  X,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useCart } from "../../context/CartContext";

const ProductInfo = ({ product }) => {
  const [quantity, setQuantity] = useState(1);
  const [showCartMessage, setShowCartMessage] = useState(false);

  const { addToCart } = useCart();
  const navigate = useNavigate();

  const increase = () => {
    setQuantity((prev) => prev + 1);
  };

  const decrease = () => {
    if (quantity > 1) {
      setQuantity((prev) => prev - 1);
    }
  };

  const formatPrice = (price) => {
    return `TZS ${Number(price).toLocaleString()}`;
  };

  const handleAddToCart = () => {
    addToCart(product, quantity);

    // Show success message
    setShowCartMessage(true);

    // Automatically hide after 5 seconds
    setTimeout(() => {
      setShowCartMessage(false);
    }, 5000);
  };

  return (
    <div className="relative">

      {/* Category */}
      <p className="text-sm font-semibold text-green-600 uppercase tracking-wide">
        {product.category?.title}
      </p>

      {/* Product Name */}
      <h1
        className="
          mt-4
          text-3xl
          lg:text-4xl
          font-bold
          text-gray-900
        "
      >
        {product.name}
      </h1>

      {/* Price */}
      <p
        className="
          mt-4
          text-3xl
          font-bold
          text-green-600
        "
      >
        {formatPrice(product.price)}
      </p>

      {/* Description */}
      <p
        className="
          mt-5
          text-gray-600
          leading-relaxed
        "
      >
        {product.shortDescription}
      </p>

      {/* Highlights */}
      <div className="mt-8 space-y-3">
        <div className="flex items-center gap-3">
          <CheckCircle size={20} className="text-green-600" />
          <span>{product.stock}</span>
        </div>

        <div className="flex items-center gap-3">
          <CheckCircle size={20} className="text-green-600" />
          <span>Quality Assured</span>
        </div>

        <div className="flex items-center gap-3">
          <CheckCircle size={20} className="text-green-600" />
          <span>Delivery Available</span>
        </div>
      </div>

      {/* Quantity */}
      <div className="mt-8">
        <p className="font-semibold text-gray-900 mb-3">
          Quantity
        </p>

        <div
          className="
            inline-flex
            items-center
            border
            border-gray-300
            rounded-xl
            overflow-hidden
          "
        >
          <button
            onClick={decrease}
            className="
              p-3
              hover:bg-gray-100
              transition
            "
          >
            <Minus size={18} />
          </button>

          <span className="px-6 font-semibold">
            {quantity}
          </span>

          <button
            onClick={increase}
            className="
              p-3
              hover:bg-gray-100
              transition
            "
          >
            <Plus size={18} />
          </button>
        </div>
      </div>

      {/* Buttons */}
      <div
        className="
          mt-10
          space-y-4
          flex
          flex-col
          md:flex-row
          md:items-center
          md:gap-4
        "
      >
        {/* Add to Cart */}
        <button
          onClick={handleAddToCart}
          className="
            w-full
            flex
            items-center
            justify-center
            gap-2
            bg-green-600
            text-white
            py-4
            rounded-xl
            font-semibold
            hover:bg-green-700
            transition
          "
        >
          <ShoppingCart size={20} />
          Add to Cart
        </button>

        {/* WhatsApp */}
        <button
          className="
            w-full
            flex
            items-center
            justify-center
            gap-2
            border
            border-green-600
            text-green-600
            py-4
            rounded-xl
            font-semibold
            hover:bg-green-50
            transition
          "
        >
          <MessageCircle size={20} />
          Contact via WhatsApp
        </button>
      </div>

      {/* Add to Cart Success Message */}
      {showCartMessage && (
        <div
          className="
            mt-5
            flex
            items-center
            justify-between
            gap-4
            bg-green-50
            border
            border-green-200
            rounded-xl
            p-4
            shadow-sm
          "
        >
          <div className="flex items-center gap-3">
            <CheckCircle
              size={24}
              className="text-green-600 flex-shrink-0"
            />

            <div>
              <p className="font-semibold text-green-800">
                Added to cart!
              </p>

              <p className="text-sm text-green-700">
                Your item has been added successfully.
              </p>
            </div>
          </div>

          <div className="flex items-center gap-2">
            <button
              onClick={() => navigate("/cart")}
              className="
                whitespace-nowrap
                bg-green-600
                text-white
                px-4
                py-2
                rounded-lg
                text-sm
                font-semibold
                hover:bg-green-700
                transition
              "
            >
              View Cart
            </button>

            <button
              onClick={() => setShowCartMessage(false)}
              className="
                p-2
                text-gray-500
                hover:text-gray-700
                transition
              "
              aria-label="Close"
            >
              <X size={18} />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductInfo;

